import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    Container,
    Grid,
    Button,
    InputLabel,
    FormControl,
    Input,
    Typography,
    Box,
    Select,
    MenuItem,
    Tooltip,
    IconButton,
    Checkbox
} from "@material-ui/core";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import imageNotAvailable from "../../../../assests/images/img-soon.png";
import { useHistory, useLocation } from "react-router-dom";
import {
    Popover as AntdPopover,
    Input as AntdInput,
    Modal as AntdModal,
} from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentWrapper from "../../../../common/components/contentWrapper";
import { getInventoryItemsList, UpdateInventoryItemsList, UpdateMemoDetails } from "../actions/dashboardAction";
import {
    showErrorToast,
    showSuccessToast,
} from "../../../../common/components/Helper/Utils";
import { SpinnerRoundFilled } from "spinners-react";
import DeleteConfirmation from "../../../../common/components/DialogConfirmation";
import QboInvoice from "./QboInvoice";

const invoiceObj = [
    {
        id: "modelnumber",
        label: "Model",
        minWidth: 100,
        type: "search",
        required: false,
        errMsg: "Please Enter Model",
    },
    { id: "image", label: "Image", minWidth: 80, type: "image", required: false },
    {
        id: "serialno",
        label: "Serial No",
        minWidth: 80,
        type: "search",
        required: false,
        errMsg: "Please Enter Serial No",
    },
    {
        id: "description",
        label: "Product Name",
        minWidth: 140,
        type: "text",
        required: false,
    },
    {
        id: "quantity",
        label: "Qty",
        minWidth: 80,
        type: "number",
        required: true,
        errMsg: "Please enter quantity",
    },
    {
        id: "currency",
        label: "Currency",
        minWidth: 30,
        type: "select",
        required: true,
        errMsg: "Please enter rate",
    },
    {
        id: "amount",
        label: "Amount ($)",
        minWidth: 65,
        type: "amount",
        required: true,
        errMsg: "Please Enter Amount",
    },
    { id: "action", label: "Action", minWidth: 70, align: "center" },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

function EditInvoice(props) {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const history = useHistory();
    const location = useLocation();
    const { row, invoiceFilter } = location.state || {};
    const [data, setData] = useState([]);
    const [openModal, setModalOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [modelnumber, setModelNumber] = useState(null);
    const [serialno, setSerialNo] = useState(null);
    const [currency, setCurrency] = useState("USD");
    const [amount, setAmount] = useState(null);
    const [desc, setDesc] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [disabled, setDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [invoicePaidAmount, setInvoicePaidAmount] = useState(0);
    const [openQBOInvoiceModal, setOpenQBOInvoiceModal] = useState(false);
    const [invoiceId, setinvoiceId] = useState(null);
    const [accountIds, setaccountId] = useState(null);
    const accountId = window.sessionStorage.getItem('accountId');

    useEffect(() => {
        // let item = row || {};
        // setData(item);
        getInventoryItems(row?.invoicenumber);
    }, [row]);

    const getInventoryItems = (inventoryId) => {
        setIsLoading(true);
        props.getInventoryItemsList(
            inventoryId,
            (success) => {
                if (success.status === 1) {
                    const invoiceData = success?.data?.[0] || {};
                    setInvoicePaidAmount(parseFloat(invoiceData.invoicepaidamount || 0));
                    const updatedData = invoiceData
                        ?.invoiceproductdetails?.product?.map(item => ({
                            ...item,
                            isDelete: false
                        }));
                    setData(updatedData || []);
                    setIsLoading(false);
                } else {
                    showErrorToast(success.message);
                    setIsLoading(false);
                }
            },
            (error) => {
                showErrorToast(error);
                setIsLoading(false);
            }
        );
    };

    const handleModalOpen = (item) => {
        const { modelnumber, miscmodelno, serialno, description, quantity, amount, technical_details } = item || {};
        const { product_title, model_number } = technical_details || {};
        setCurrentItem(item);
        setModalOpen(true);
        setModelNumber(modelnumber || model_number || miscmodelno || null);
        setSerialNo(serialno || null);
        setDesc(description || product_title || null);
        setQuantity(quantity || null);
        setAmount(amount || null);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setCurrentItem(null);
        setModelNumber(null);
        setSerialNo(null);
        setDesc(null);
        setQuantity(null);
        setAmount(null);
        setDeleteModal(false);
    };

    const handleDeleteModal = (item) => {
        setCurrentItem(item);
        setDeleteModal(true);
    }

    const handleDelete = () => {
        const updatedArray = data?.map(item =>
            item.invoicedetailsid === currentItem?.invoicedetailsid
                ? { ...item, isDelete: true }
                : item
        );
        const newTotal = updatedArray
            .filter(item => !item.isDelete)
            .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

        if (newTotal < parseFloat(invoicePaidAmount)) {
            showErrorToast(
                `Cannot delete this item, the total invoice amount ($${newTotal.toFixed(2)}) must not be lower than the amount already paid ($${parseFloat(invoicePaidAmount).toFixed(2)}).`
            );
            return;
        }
        setData(updatedArray);
        handleCloseModal();
    }

    const handleCloseQBOInvoice = () => {
        setOpenQBOInvoiceModal(false);
    }

    const handleGoBack = (invoiceFilter) => {
        history.push({
            pathname: "/invoices",
            state: { invoiceFilter }
        });
    }

    const handleEdit = () => {
        const updatedData = data?.map(item => {
            if (item.invoicedetailsid === currentItem.invoicedetailsid) {
                return {
                    ...item,
                    amount: parseFloat(amount) || 0,
                };
            }
            return item;
        });

        const totalAmount = updatedData
            .filter(item => !item.isDelete)
            .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

        if (totalAmount < invoicePaidAmount) {
            showErrorToast(
                `The total invoice amount($${totalAmount.toFixed(2)}) must not be lower than the amount already paid ($${invoicePaidAmount.toFixed(2)}).`
            );
            return;
        }
        setData(updatedData);
        handleCloseModal();
    };

    const handleUpdateInvoice = () => {
        setDisabled(true);
        setIsLoading(true);
        let payload = {
            invoiceId: data?.[0]?.invoiceid || null,
            product: data,
        }
        props.UpdateInventoryItemsList(
            payload,
            (success) => {
                if (success.status === 1) {
                    setDisabled(false);
                    setIsLoading(false);
                    handleCloseModal();
                    showSuccessToast(success?.message || "Updated Successfully");

                    // If backend reports this invoice was synced to QBO, open the QboInvoice modal
                    // Response shape may vary: check multiple nesting levels (res, res.data, res.invoice)
                    const res = success || {};
                    const nested = res.data || res.invoice || {};
                    const isQboSynced = !!(res.is_invoice_qbo_synced || nested.is_invoice_qbo_synced);
                    const returnedInvoiceId = res.invoiceid || nested.invoiceid || payload.invoiceId || (data?.[0]?.invoiceid) || null;
                    const returnedAccountId = res.accountid || nested.accountid || null;

                    if (isQboSynced) {
                        // Ensure we have ids before opening
                        setinvoiceId(returnedInvoiceId);
                        setaccountId(returnedAccountId);
                        setOpenQBOInvoiceModal(true);
                    } else {
                        // Normal flow: refresh list
                        getInventoryItems(row?.invoicenumber);
                    }
                } else {
                    setDisabled(false);
                    setIsLoading(false);
                    showErrorToast(success?.message);
                    getInventoryItems(row?.invoicenumber);
                }
            },
            (error) => {
                setDisabled(false);
                setIsLoading(false);
                showErrorToast(error);
                getInventoryItems(row?.invoicenumber);
            }
        );
    };

    const getContentView = () => {
        return (
            <Container maxWidth="md">
                {isLoading ?
                    <div class="d-spinner">
                        <SpinnerRoundFilled
                            size={51}
                            thickness={125}
                            speed={80}
                            color="rgba(57, 107, 172, 1)"
                            className="spp"
                            enabled={isLoading}
                        />
                    </div> :
                    <form key={1}>
                        <Grid container xs={12} sm={12}>
                            <h1 style={{ display: "flex", alignItems: "center" }}>
                                <ArrowBackIcon
                                    style={{
                                        color: "action",
                                        paddingRight: "15px",
                                        fontSize: 40,
                                        cursor: "pointer",
                                    }}
                                    onClick={() => { handleGoBack(invoiceFilter) }}
                                >
                                    {" "}
                                </ArrowBackIcon>
                                Edit Invoice
                            </h1>
                        </Grid>
                        <TableContainer
                            sx={{ maxHeight: 440, marginTop: "20px", marginBottom: "20px" }}
                        >
                            <Table aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {/* <StyledTableCell align="center" padding="checkbox"></StyledTableCell> */}
                                        {invoiceObj
                                            .filter(({ id }) => id !== "currency")
                                            .map(({ id, align, minWidth, label }) => (
                                                <StyledTableCell
                                                    key={id}
                                                    align={align}
                                                    style={{ minWidth }}
                                                >
                                                    {label}
                                                </StyledTableCell>
                                            ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(data?.filter(item => !item.isDelete)?.length === 0) || (data?.length === 0) ? (
                                        <StyledTableRow>
                                            <TableCell colSpan={11} style={{ textAlign: "center" }}>
                                                No record found
                                            </TableCell>
                                        </StyledTableRow>
                                    ) : (
                                        data?.filter(item => !item.isDelete)?.map((row, idx) => {
                                            const {
                                                invoicedetailsid,
                                                product_imagepaths,
                                                technical_details,
                                                miscimages,
                                                miscmodelno,
                                                inventoryid
                                            } = row;
                                            const {
                                                front,
                                                back,
                                                left,
                                                right,
                                                wrist_shot,
                                                buckle_closed,
                                                buckle_opened,
                                                free_form,
                                            } = miscimages ?? {};
                                            const { product_title, model_number } = technical_details || {};
                                            return (
                                                <StyledTableRow
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={invoicedetailsid}
                                                >
                                                    {/* <TableCell align="center" padding="checkbox">
                                                        <Checkbox
                                                            checked={selectedRows.includes(inventoryid)}
                                                            onChange={() => handleCheckboxChange(inventoryid)}
                                                        />
                                                    </TableCell> */}
                                                    {invoiceObj
                                                        .filter(({ id }) => id !== "currency")
                                                        .map(({ id, align, type }) => {
                                                            if (id === "action") {
                                                                return (
                                                                    <TableCell
                                                                        key={id}
                                                                        align={align}
                                                                        style={{ padding: 10 }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                gap: "10px",
                                                                            }}
                                                                        >
                                                                            <IconButton
                                                                                className="color-000"
                                                                                onClick={() => {
                                                                                    handleModalOpen(row);
                                                                                }}
                                                                                style={{ width: "32px", height: "32px" }}
                                                                            >
                                                                                <EditIcon style={{ width: "19px" }} />
                                                                            </IconButton>
                                                                            <IconButton
                                                                                className={data?.filter(item => !item.isDelete)?.length === 1 ? null : "color-000"}
                                                                                onClick={() => handleDeleteModal(row)}
                                                                                disabled={data?.filter(item => !item.isDelete)?.length === 1}
                                                                                style={{ width: "32px", height: "32px" }}
                                                                            >
                                                                                <DeleteIcon style={{ width: "19px" }} />
                                                                            </IconButton>
                                                                        </div>
                                                                    </TableCell>
                                                                );
                                                            }
                                                            return (
                                                                <TableCell key={id} align={align}>
                                                                    {type === "image" ? (
                                                                        <img
                                                                            src={
                                                                                front ||
                                                                                back ||
                                                                                left ||
                                                                                right ||
                                                                                wrist_shot ||
                                                                                buckle_closed ||
                                                                                buckle_opened ||
                                                                                free_form ||
                                                                                product_imagepaths?.images?.[0] ||
                                                                                imageNotAvailable
                                                                            }
                                                                            width="35"
                                                                            height="55"
                                                                            alt="Image"
                                                                        />
                                                                    ) : id === "rate" || id === "amount" ? (
                                                                        `${row[id]}`
                                                                    ) : id === "description" ? (
                                                                        (product_title || row[id])
                                                                            ?.length > 50 ? (
                                                                            `${row[id]?.slice(0, 50)}...`
                                                                        ) : (
                                                                            row[id] || product_title
                                                                        )
                                                                    ) : id === "modelnumber" ? (
                                                                        model_number || miscmodelno || row[id]
                                                                    ) : (
                                                                        row[id]
                                                                    )}
                                                                </TableCell>
                                                            );
                                                        })}
                                                </StyledTableRow>
                                            );
                                        })
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {/* <Grid
                        container
                        item
                        xs={12}
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "15px",
                        }}
                        className="space-marign-bottom-10"
                    >
                        <Button
                            variant="contained"
                            id="demo-customized-button"
                            disableElevation
                            onClick={() => history.push("/invoices")}
                            className="text-capitalize primary-bg color-white"
                        >
                            CANCEL
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            id="demo-customized-button"
                            disableElevation
                            onClick={() => { }}
                            className="text-capitalize primary-bg color-white"
                        >
                            UPDATE
                        </Button>
                    </Grid> */}
                        <Grid
                            container
                            item
                            xs={12}
                            sm={12}
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Button
                                variant="text"
                                style={{
                                    background: "#000",
                                    color: "#fff",
                                    float: "right",
                                    marginTop: 20,
                                    marginBottom: 20,
                                }}
                                // disabled={data?.filter(item => !item.isDelete)?.length === 1 || disabled}
                                disabled={disabled}
                                onClick={handleUpdateInvoice}
                            >
                                Update Invoice
                            </Button>
                        </Grid>
                    </form>
                }
                <AntdModal open={openModal} footer={null} onCancel={handleCloseModal}>
                    <Box>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Edit Item
                        </Typography>
                        <form key={3} onSubmit={handleSubmit(handleEdit)}>
                            {invoiceObj.map((column) => {
                                return (
                                    <>
                                        {column.id !== "action" &&
                                            (column.type === "text" || column.type === "number") && (
                                                <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                                                    <InputLabel
                                                        htmlFor="component-simple"
                                                        className="color-292C2F"
                                                    >
                                                        {column.label}
                                                    </InputLabel>
                                                    <Input
                                                        id={column.id}
                                                        value={
                                                            column.id === "description"
                                                                ? desc
                                                                : column.id === "quantity"
                                                                    ? quantity
                                                                    : 1
                                                        }
                                                        // {...register(column.id, {
                                                        //     required: column.required ? column.errMsg : false,
                                                        // })}
                                                        inputProps={{
                                                            type: column.type,
                                                            autoComplete: "off",
                                                        }}
                                                        readOnly={true}
                                                        disableUnderline={false}
                                                        disabled={true}
                                                    />
                                                    {errors[column.id] && (
                                                        <span style={{ color: "red" }}>
                                                            {column.errMsg}
                                                        </span>
                                                    )}
                                                </FormControl>
                                            )}
                                        {(column.id === "modelnumber" ||
                                            column.id === "serialno") && (
                                                <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                                                    <InputLabel
                                                        htmlFor="component-simple"
                                                        className="color-292C2F"
                                                    >
                                                        {column.label}
                                                    </InputLabel>
                                                    <Input
                                                        id={column.id}
                                                        value={
                                                            column.id === "modelnumber"
                                                                ? modelnumber
                                                                : column.id === "serialno"
                                                                    ? serialno
                                                                    : null
                                                        }
                                                        // {...register(column.id, {
                                                        //     required: column.required ? column.errMsg : false,
                                                        // })}
                                                        inputProps={{
                                                            type: column.type,
                                                            autoComplete: "off",
                                                        }}
                                                        readOnly={true}
                                                        disableUnderline={false}
                                                        disabled={true}
                                                    />
                                                    {errors[column.id] && (
                                                        <span style={{ color: "red" }}>{column.errMsg}</span>
                                                    )}
                                                </FormControl>
                                            )}
                                        {(column.type === "select" || column.type === "amount") && (
                                            <FormControl
                                                className={`form-width-${column.minWidth} margin-t-b-20 margin-p-b-20`}
                                                style={{
                                                    marginRight: column.type === "select" ? "16px" : 0,
                                                }}
                                            >
                                                <InputLabel
                                                    htmlFor="component-simple"
                                                    className="color-292C2F"
                                                >
                                                    {column.label}
                                                </InputLabel>
                                                {column.type === "select" ? (
                                                    <Select
                                                        labelId="demo-simple-select-outlined-label"
                                                        id="demo-simple-select-outlined"
                                                        value={currency}
                                                        onChange={(e) => {
                                                            setCurrency(e.target.value);
                                                        }}
                                                        disabled={true}
                                                    >
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="HK$">HK$</MenuItem>
                                                        <MenuItem value="Euro">Euro</MenuItem>
                                                        <MenuItem value="AED">AED</MenuItem>
                                                    </Select>
                                                ) : (
                                                    <Input
                                                        id="component-simple"
                                                        {...register(column.id, { required: true })}
                                                        inputProps={{
                                                            type: "text",
                                                            maxLength: "15",
                                                            autoComplete: "off",
                                                        }}
                                                        disableUnderline={false}
                                                        value={amount}
                                                        onChange={(e) => {
                                                            const val = e.target.value.replace(
                                                                /[^0-9\.]/g,
                                                                ""
                                                            );
                                                            setAmount(val);
                                                        }}
                                                    />
                                                )}
                                                {errors[column.id] && (
                                                    <span style={{ color: "red" }}>{column.errMsg}</span>
                                                )}
                                            </FormControl>
                                        )}
                                    </>
                                );
                            })}
                            <Box
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "15px",
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    onClick={handleCloseModal}
                                    style={{
                                        background: "#fff",
                                        color: "#000",
                                        marginTop: "20px",
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="text"
                                    style={{
                                        background: "#000",
                                        color: "#fff",
                                        marginTop: "20px",
                                    }}
                                >
                                    Submit
                                </Button>
                            </Box>
                        </form>
                    </Box>
                </AntdModal>

                {deleteModal &&
                    <DeleteConfirmation
                        title={"Delete"}
                        message={
                            <>
                                Are you sure you want to <b>Delete</b>?
                            </>
                        }
                        openDeleteModal={deleteModal}
                        setOpenDeleteModal={handleCloseModal}
                        handleConfirmation={handleDelete}
                        disabled={disabled}
                    />
                }
                {
                    <QboInvoice
                        open={openQBOInvoiceModal}
                        handleClose={handleCloseQBOInvoice}
                        invoiceId={invoiceId}
                        accountId={accountId}
                        onQboSuccess={() => {
                            getInventoryItems(row?.invoicenumber);
                        }}
                    />
                }
            </Container>
        );
    };
    return <ContentWrapper contentView={getContentView()} />;
}

function mapStateToProps({ }) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        UpdateMemoDetails,
        getInventoryItemsList,
        UpdateInventoryItemsList
    }, dispatch);
}

EditInvoice.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditInvoice);
